import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import { config } from 'utils/apiEndPoint';

export async function logIn(payload) {
    try {
        const response = await axios.post(`${config?.authentication?.signIn}`, payload);
        const d = response?.data;
        const access = d?.access || d?.access_token || d?.token;
        const refresh = d?.refresh || d?.refresh_token;
        if (access) localStorage.setItem('access-token', access);
        if (refresh) localStorage.setItem('refresh-token', refresh);
        return response;

    } catch (e) {
        console.error('Error in signIn API:', e);
        throw e;
    }
}      
export async function createNewUser(payload) {
    try {
        const response  = await axios.post(`${config?.authentication?.signUp}`, payload)
        console.log(response, 'checking the response')
        // return response
    }  catch(e) {
        console.log(e)
    }
}

// Function to get the current user
export function getCurrentUser() {
    try {
        const token = localStorage.getItem('token');
        return jwtDecode(token);
    } catch (error) {
        return null;
    }
};
